var _path, _rect, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostEventIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 0C4.08668 0 4.22976 0.0592632 4.33525 0.164752C4.44074 0.270242 4.5 0.413316 4.5 0.5625V1.125H13.5V0.5625C13.5 0.413316 13.5593 0.270242 13.6648 0.164752C13.7702 0.0592632 13.9133 0 14.0625 0C14.2117 0 14.3548 0.0592632 14.4602 0.164752C14.5657 0.270242 14.625 0.413316 14.625 0.5625V1.125H15.75C16.3467 1.125 16.919 1.36205 17.341 1.78401C17.7629 2.20597 18 2.77826 18 3.375V15.75C18 16.3467 17.7629 16.919 17.341 17.341C16.919 17.7629 16.3467 18 15.75 18H2.25C1.65326 18 1.08097 17.7629 0.65901 17.341C0.237053 16.919 0 16.3467 0 15.75V3.375C0 2.77826 0.237053 2.20597 0.65901 1.78401C1.08097 1.36205 1.65326 1.125 2.25 1.125H3.375V0.5625C3.375 0.413316 3.43426 0.270242 3.53975 0.164752C3.64524 0.0592632 3.78832 0 3.9375 0V0ZM15.1358 3.375H2.86313C2.52562 3.375 2.25 3.627 2.25 3.9375V5.0625C2.25 5.373 2.5245 5.625 2.86313 5.625H15.1369C15.4744 5.625 15.75 5.373 15.75 5.0625V3.9375C15.75 3.627 15.4755 3.375 15.1358 3.375ZM12.9375 7.875C12.7883 7.875 12.6452 7.93426 12.5398 8.03975C12.4343 8.14524 12.375 8.28832 12.375 8.4375V9.5625C12.375 9.71168 12.4343 9.85476 12.5398 9.96025C12.6452 10.0657 12.7883 10.125 12.9375 10.125H14.0625C14.2117 10.125 14.3548 10.0657 14.4602 9.96025C14.5657 9.85476 14.625 9.71168 14.625 9.5625V8.4375C14.625 8.28832 14.5657 8.14524 14.4602 8.03975C14.3548 7.93426 14.2117 7.875 14.0625 7.875H12.9375Z",
    fill: "#002E6E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 8,
    height: 3,
    fill: "#002E6E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 5.05,
    fill: "white",
    stroke: "#002E6E",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 13.3999L13.8125 16.3999L12.5 15.0363",
    stroke: "#002E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostEventIcon);
export default __webpack_public_path__ + "static/media/post-event-icon.9fade72e0b9e43df311b69fdb6ed37d5.svg";
export { ForwardRef as ReactComponent };